import React, { useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Sample_Report_Filter from "./sample_report_filter/Sample_Report_Filter";
import "./Sample_Report.css";
import Sample_Report_Table from "./sample_report_table/Sample_Report_Table";
import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import {
  GetSampleReport,
  GetSampleReportYearly,
} from "../../../../../features/admin/report_generator/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../utils/fixIDS";

const Sample_Report = () => {
  const permissions = useSelector((state) => state.auth.permissions);
  const haveReportPermission = permissions?.includes(FixIDS.sample_report.Report);


  const [show, setShow] = useState(false);

  const [searchParams, setSearchParams] = useState({
    createdAt: "",
    unique_id: "",
    method_of_testing: "",
    tat: "",
    sample_management_status_id: "",
    end_date: "",
    start_date: "",
    customer_id: "",
    year: "",
  });
  const dispatch = useDispatch();
  const [showLottie, setShowLottie] = useState(true);
  const [reportPath, setReportPath] = useState("");
  const reportgenerate = async () => {
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(
      GetSampleReport({
        createdAt: searchParams.createdAt || "",
        unique_id: searchParams.unique_id || "",
        method_of_testing: searchParams.method_of_testing || "",
        tat: searchParams.tat || "",
        sample_management_status_id:
          searchParams.sample_management_status_id || "",
        name: searchParams,
        start_date: searchParams.start_date || "",
        end_date: searchParams.end_date || "",
        tat: searchParams.tat || "",
        customer_id: searchParams.customer_id || "",
      }),
    );

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      setReportPath(path);
      setShowLottie(false);
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };
  console.log(searchParams.year, "searchParams.year");

  const reportgenerateYearly = async () => {
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(
      GetSampleReportYearly({
        createdAt: searchParams.createdAt || "",
        unique_id: searchParams.unique_id || "",
        method_of_testing: searchParams.method_of_testing || "",
        tat: searchParams.tat || "",
        sample_management_status_id:
          searchParams.sample_management_status_id || "",
        name: searchParams,
        start_date: searchParams.start_date || "",
        end_date: searchParams.end_date || "",
        tat: searchParams.tat || "",
        customer_id: searchParams.customer_id || "",
        year: searchParams.year || "",
      }),
    );

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      setReportPath(path);
      setShowLottie(false);
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };
  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Sample Report" />
      </div>

      <div className="Sample_Report_Filter_div">
        <Sample_Report_Filter
          setShow={setShow}
          setSearchName={setSearchParams}
          reportgenerate={reportgenerate}
          reportgenerateYearly={reportgenerateYearly}
        />
      </div>

      <div className="report_table_div">
        { haveReportPermission && <Sample_Report_Table searchName={searchParams} />}
      </div>

      <Common_Report_Offcanvas
        reportPath={reportPath}
        reportgenerate={reportgenerate}
        setShowLottie={setShowLottie}
        showLottie={showLottie}
        title={"Sample Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Sample_Report;
